import React from 'react';
import styles from './style.module.scss';

export default () => {
  return <div className={styles['separator']} />;
};
